export const AML_RISK_LEVELS = [
  "Unacceptable Risk",
  "Increased Risk",
  "Standard Risk",
  "Low Risk",
  "Exempted Risk",
];

const LEGACY_AML_RISK_LEVEL_MAP = {
  Acceptable: "Low Risk",
  Increased: "Increased Risk",
  Unacceptable: "Unacceptable Risk",
};

export const normalizeAmlRiskLevel = (level) => {
  if (level == null) return level;
  const trimmed = String(level).trim();
  if (!trimmed) return trimmed;
  return LEGACY_AML_RISK_LEVEL_MAP[trimmed] ?? trimmed;
};

export const getAmlRiskLevelLabel = (level) => normalizeAmlRiskLevel(level) ?? "";

export const isHighAmlRisk = (level) => {
  const normalized = normalizeAmlRiskLevel(level);
  return ["Increased Risk", "Unacceptable Risk"].includes(normalized);
};
